import { Component, OnInit, Input, Output, EventEmitter, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']

})
export class CreateComponent implements OnInit {

  @Input()
  allowImport: Boolean;

  @Input()
  superUser: Boolean;

  @Input()
  primaryColor: string;
  @Input()
  private secondaryColor: string;

  @Output() createWithBackgroundClick = new EventEmitter<void>();
  @Output() createWithPosterClick = new EventEmitter<void>();
  @Output() importClick = new EventEmitter<void>();

  constructor(private renderer: Renderer2) {

  }

  ngOnInit() {
  }

  ngAfterViewInit(){

  }

  goToBackgroundGallery(): void{
    this.createWithBackgroundClick.emit();
  }

  goToPosterGallery(): void{
    this.createWithPosterClick.emit();
  }

  goToImport(): void{
    this.importClick.emit();
  }

  hoverColor(e: any, isOn: boolean): void{
    if(isOn==true) this.renderer.setStyle(e.target, 'background-color', this.secondaryColor);
    else this.renderer.setStyle(e.target, 'background-color', this.primaryColor);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/create/create.component.ts